import { blockedTextReason } from './text-filter.ts';

export const HANDLE_MIN_LENGTH = 3;
export const HANDLE_MAX_LENGTH = 24;

/** System routes and words a channel can never claim. */
export const RESERVED_HANDLES: ReadonlySet<string> = new Set([
  'api', 'admin', 'auth', 'live', 'login', 'logout', 'signup', 'signin', 'settings', 'privacy',
  'terms', 'support', 'help', 'about', 's', 'go-live', 'golive', 'watch', 'stream', 'streams',
  'channel', 'channels', 'assets', 'static', 'media', 'obs', 'dashboard', 'account', 'me',
  'zip2live', 'ziptolive', 'official', 'staff', 'moderator', 'security', 'status', 'blog',
  'docs', 'press', 'legal', 'dmca', 'copyright', 'report', 'verify', 'claim', 'www', 'mail',
  'root', 'null', 'undefined', 'faq', 'contact', 'contact-us', 'account-deleted', 'appeals', 'review', 'tos', 'unsubscribe', 'following', 'favicon.ico', 'robots.txt', 'sitemap.xml',
  // Paths beside /api/v1/channels/:handle, so no channel's API address is shadowed by them.
  'check-handle', 'claim-handle', 'overlay',
]);

export type HandleCheck =
  | { ok: true; handle: string }
  | { ok: false; reason: 'too_short' | 'too_long' | 'invalid_characters' | 'reserved' };

/** Canonical form: trimmed, lowercase. Uniqueness is enforced on this value. */
export function normalizeHandle(input: string): string {
  return input.trim().replace(/^@/, '').toLowerCase();
}

export function validateHandle(input: string): HandleCheck {
  const handle = normalizeHandle(input);
  if (handle.length < HANDLE_MIN_LENGTH) return { ok: false, reason: 'too_short' };
  if (handle.length > HANDLE_MAX_LENGTH) return { ok: false, reason: 'too_long' };
  // Letters, digits, single inner hyphens or underscores. No dots so handles never look like files.
  if (!/^[a-z0-9](?:[a-z0-9]|[-_](?=[a-z0-9]))*$/.test(handle)) {
    return { ok: false, reason: 'invalid_characters' };
  }
  // A link with a slur or a sexual word in it can't be claimed either.
  if (RESERVED_HANDLES.has(handle) || blockedTextReason(handle)) return { ok: false, reason: 'reserved' };
  return { ok: true, handle };
}
